export default "__VITE_IMAGE_ASSET__13fe9ea4__";